/**
 * Configuración institucional · backend real (`/api/configuracion`).
 * Cache local en `ct_admin_config_v1` para lecturas síncronas.
 */
import { api } from "@/services/api";
import { isAdminAuthenticated } from "@/data/adminAuthStore";

const KEY = "ct_admin_config_v1";

const DEFAULTS = {
  institucion: {
    nombre: "Casino Tampiqueño",
    logo: "",
    correoInstitucional: "contacto@casinotampiqueno.mx",
    telefono: "",
  },
  venta: {
    // Auditoría 055-079: Smart Queue 10 min, inactividad 3 min.
    // Se ELIMINÓ `limiteBoletosDefault` (aplica sólo por evento).
    smartQueueMaxMinutos: 10,
    inactividadMinutos: 3,
  },
  recepcion: {
    // Reglas institucionales · siempre habilitadas.
    busquedaPorNombre: true,
    busquedaPorNumeroSocio: true,
    validacionManual: true,
  },
  pagos: {
    // Fase D · integración BanBajío. Los secretos regresan enmascarados
    // desde el backend (`•••••••`) y sólo se sobrescriben cuando el
    // usuario captura un valor nuevo.
    modo: "sandbox", // sandbox | produccion
    merchantId: "",
    apiKey: "",
    secretKey: "",
    endpointSandbox: "",
    endpointProduccion: "",
  },
};

const isBrowser = () =>
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

const merge = (a, b) => {
  const out = { ...a };
  Object.keys(b || {}).forEach((k) => {
    out[k] =
      b[k] && typeof b[k] === "object" && !Array.isArray(b[k])
        ? merge(a[k] || {}, b[k])
        : b[k];
  });
  return out;
};

const writeCache = (cfg) => {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify(cfg));
  } catch {
    /* ignore */
  }
};

/** Lectura síncrona desde cache (merged con defaults). */
export const leerConfig = () => {
  if (!isBrowser()) return DEFAULTS;
  try {
    const raw = window.localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return merge(DEFAULTS, parsed);
  } catch {
    return DEFAULTS;
  }
};

/** Hidrata cache desde backend. */
export const hidratarConfig = async () => {
  if (!isAdminAuthenticated()) return DEFAULTS;
  try {
    const { data } = await api.get("/configuracion");
    if (data && typeof data === "object") {
      const merged = merge(DEFAULTS, data);
      writeCache(merged);
      return merged;
    }
  } catch {
    /* ignore */
  }
  return leerConfig();
};

/** Persiste cambios en backend + actualiza cache. */
export const guardarConfig = async (config) => {
  if (!isAdminAuthenticated()) return null;
  try {
    const { data } = await api.put("/configuracion", config || {});
    const merged = merge(DEFAULTS, data || {});
    writeCache(merged);
    return merged;
  } catch (err) {
    return { error: err?.response?.data?.detail || "network" };
  }
};
